<template>
  <div>
    <el-form size="medium">
      <div style="text-align: left; margin-left: 10px;">
        <!--        <h3 style="display:inline-block">Candidate Data</h3>-->
        <el-main>
          <el-collapse v-model="reminderActiveName" @change="handleReminderChange" accordion>
            <el-collapse-item name="reminder-1">
              <template slot="title">
                <span style="font-size: 16px;">Reminder {{ "[" + reminderStatus + "]" }}</span>
              </template>
              <div style="font-size: 16px; word-break: break-word; text-align: justify;">
                <div>
                  Kindly note that in the recruitment for senior positions at the rank of Professor and Associate Professor with substantiation, reference letters will not be requested until the candidate is shortlisted. Please note the automatic dependent reference request function is now disabled in the system. Therefore, the recruiting unit is reminded to solicit BOTH dependent and independent letters in due course. 
                </div>
                <br />
                <div>
                  Please note the automatic dependent reference request function for this group of applicants is now disabled in the system.
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div id='personal-info' style="margin-top: 10px;">
            <h4>Personal Information</h4>
            <el-form-item prop="appointment_title">
              <ScreeningLabelComponent label="Title"></ScreeningLabelComponent>
              <el-select v-model="templateData.appointment_title" placeholder="please select your title"
                         :disabled="true">
                <el-option label="Prof." value="prof"></el-option>
                <el-option label="Dr." value="dr"></el-option>
                <el-option label="Mr." value="mr"></el-option>
                <el-option label="Ms." value="ms"></el-option>
                <el-option label="Mrs." value="mrs"></el-option>
              </el-select>
            </el-form-item>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item prop="english_last_name">
                  <ScreeningLabelComponent label="English Last Name"></ScreeningLabelComponent>
                  <el-input :disabled="true" v-model="templateData.english_last_name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item prop="english_first_name">
                  <ScreeningLabelComponent label="English First Name"></ScreeningLabelComponent>
                  <el-input :disabled="true" v-model="templateData.english_first_name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item>
                  <ScreeningLabelComponent label="Chinese Name" :label-required="false"></ScreeningLabelComponent>
                  <el-input :disabled="true" v-model="templateData.chinese_name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item prop="university_email">
                  <ScreeningLabelComponent label="Email"></ScreeningLabelComponent>
                  <el-input :disabled="true" v-model="templateData.university_email"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="20">
                <el-form-item>
                  <ScreeningLabelComponent label="Correspondence Address"
                                           :label-required="false"></ScreeningLabelComponent>
                  <el-input :disabled="true" v-model="templateData.correspondence_address"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item prop="appointment_date">
              <ScreeningLabelComponent label="Intended Start Date"></ScreeningLabelComponent>
              <el-date-picker
                  :disabled="true"
                  v-model="templateData.appointment_date"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="Select date">
              </el-date-picker>
            </el-form-item>
          </div>
          <el-divider></el-divider>
          <br/>
          <div id="application-info">
            <h4>Application Information</h4>
            <el-form-item prop="type">
              <div style="display: flex">
                <ScreeningLabelComponent label="Tenure Stream"></ScreeningLabelComponent>
                <el-checkbox-group v-model="templateData.type" style="margin-left: 10px">
                  <el-checkbox-button :disabled="true" label="Full Professor"></el-checkbox-button>
                  <el-checkbox-button :disabled="true" label="Associate Professor"></el-checkbox-button>
                  <el-checkbox-button :disabled="true" label="Assistant Professor"></el-checkbox-button>
                </el-checkbox-group>
              </div>
              <div style="display: flex">
                <ScreeningLabelComponent label="Non-tenure Stream"></ScreeningLabelComponent>
                <el-checkbox-group v-model="templateData.type" style="margin-left: 10px">
                  <el-checkbox-button :disabled="true" label="Research Track"></el-checkbox-button>
                  <el-checkbox-button :disabled="true" label="Teaching Track"></el-checkbox-button>
                  <el-checkbox-button :disabled="true" label="Visiting Faculty"></el-checkbox-button>
                </el-checkbox-group>
              </div>
              <div v-if="Array.isArray(templateData.jobID)">
                <div v-if="templateData.jobID.length != 0">
                  <div>
                    <ScreeningLabelComponent label="Job ID"></ScreeningLabelComponent>
                  </div>
                  <div v-if="templateData.jobID.length != 0" style="margin-top: 10px; display: inline;">
                    <el-tag
                        :disable-transitions="false"
                        :key="index"
                        v-for="(jobID,index) in templateData.jobID" style="margin-bottom: 5px; margin-left: 2px">
                      {{jobID}}
                    </el-tag>
                  </div>
                </div>
              </div>
            </el-form-item>
            <el-divider></el-divider>
            <!--            <el-form-item prop="thrust">-->
            <!--              <ScreeningLabelComponent v-if="!isEmpty(localGZThrust)" label="HKUST Guangzhou Campus"></ScreeningLabelComponent>-->
            <!--            </el-form-item>-->
            <div v-for="(thrust, index) in templateData.thrust"
                 :key="index">
              <!--                <p style="font-size: 20px">{{ localGZThrustNames[name] }}</p>-->
              <div
                  v-if="availableUnit.includes(correctThrust(thrust)) || highPrivilegeCondition() || referToListFlag">
                <el-tag v-if="correctThrust(thrust) != 'Others'" effect="dark" :color="otherHubCheckBoxColor(thrust)"
                        :class="otherHubCheckBoxClass(thrust)">
                  {{ getAbbreviation(thrust) }}
                </el-tag>
                <el-tag v-if="correctThrust(thrust) == 'Others'" effect="dark" :color="otherHubCheckBoxColor(thrust)"
                        :class="otherHubCheckBoxClass(thrust)">
                  {{ correctThrust(thrust) }}({{ templateData.other_thrust_specify }})
                </el-tag>
                <el-tag effect="dark" :color="otherHubCheckBoxColor(thrust)" :class="otherHubCheckBoxClass(thrust)"
                        v-if="thrustPoints.gz[thrust] && pointsDataCondition(thrustPoints.gz[thrust], thrust)">
                  # of Reviewer:
                  {{ thrustPoints.gz[thrust].numOfReviewer.toPrecision(1) }},
                  Avg: {{ thrustPoints.gz[thrust].avg.toPrecision(2) }}, Highest Point:
                  {{ thrustPoints.gz[thrust].highestPoint.toPrecision(2) }}
                </el-tag>
                <span v-if="!declineRecommendFlag">
                <el-select v-model="screeningStatus[thrust]" placeholder="Select Status"
                           :disabled="offerStatusTest(screeningStatus[thrust], thrust)"
                           v-if="statusCondition(thrustPoints.gz[thrust], thrust) == 'decline_enable'">
                  <el-option
                      v-for="item in statusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
                <el-select v-model="screeningStatus[thrust]" placeholder="Select Status"
                           :disabled="offerStatusTest(screeningStatus[thrust], thrust)"
                           v-if="statusCondition(thrustPoints.gz[thrust], thrust) == 'decline_disable'">
                  <el-option
                      v-for="item in statusOptionsDeclineDisable"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
                  <!--                  <el-button style="margin-left: 10px" @click="clearStatus(index)" v-if="role != 'Search Committee Member' && role != 'Reviewers'">-->
                  <!--                    Clear-->
                  <!--                  </el-button>-->
                <el-button style="margin-left: 10px"
                           :disabled="offerStatusTest(screeningStatus[thrust], thrust)"
                           @click="submitStatus(screeningStatus[thrust] ,'gz',thrust)"
                           v-if="statusCondition(thrustPoints.gz[thrust], thrust) != 'none'">
                  Submit Status
                </el-button>
                <el-button style="margin-left: 10px"
                           @click="sendDeclineRecommendation(thrust)"
                           type="warning"
                           v-if="statusCondition(thrustPoints.gz[thrust], thrust) == 'decline_disable' && (unitRoleDetection(thrust, 'Head') || unitRoleDetection(thrust, 'Search Committee Chair'))">
                  Recommend For Decline
                </el-button>
                <el-popover
                    placement="top-start"
                    width="500"
                    trigger="hover"
                    :content="itemDescription.declineRecommendDescription"
                    v-if="statusCondition(thrustPoints.gz[thrust], thrust) == 'decline_disable' && (unitRoleDetection(thrust, 'Head') || unitRoleDetection(thrust, 'Search Committee Chair'))">
                  <i style="margin-left: 5px" slot="reference" class="el-icon-info"></i>
                </el-popover>
                  <el-select v-model="streamType" placeholder="Select type"
                             style="margin-left: 10px"
                             v-if="(offerStatus == 'offering' || offerStatus == 'end') && (offerAdminFlag && offerStatusPositiveTest(thrust) && offerFlag)"
                             :rules="{required: true, message: 'Please select type', trigger: 'change'}">
                    <el-option
                        v-for="item in streamTypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
<!--                  <span>-->
<!--                    Intended Start Date-->
<!--                  </span>-->
                  <el-date-picker
                      style="margin-left: 10px"
                      v-model="onBoardingDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="Intended start date"
                      v-if="(offerStatus == 'prepare' || offerStatus == 'collecting') && (offerAdminFlag && offerStatusPositiveTest(thrust) && offerFlag)">
                  </el-date-picker>
                  <el-button style="margin-left: 10px"
                             v-if="offerAdminFlag && offerStatusPositiveTest(thrust) && offerFlag"
                             @click="offerStatusChange(thrust)">{{ offerStatusButtonName[offerStatus] }}</el-button>
                  <el-tag
                    v-if="(offerStatus == 'submitted' || offerStatus == 'collecting') && (offerAdminFlag && offerStatusPositiveTest(thrust) && offerFlag)"
                  >
                    Preboarding Data Status: {{ offerStatus }}
                  </el-tag>
                  <el-tag
                    v-if="(offerStatus == 'submitted') && (offerAdminFlag && offerStatusPositiveTest(thrust) && offerFlag) && offerSyncStatus"
                  >
                    {{ offerSyncStatus }}
                  </el-tag>
                </span>
                <span v-if="declineRecommendFlag && thrust == currentDeclinedUnit && unitRoleDetection(thrust, 'Dean')">
                  <el-button
                      type="success"
                      @click="declineRecommendOperation('Approved')">
                    Approve
                  </el-button>
                  <el-button
                      type="danger"
                      @click="declineRecommendOperation('Rejected')">
                    Reject
                  </el-button>
                </span>
                <br/>
                <br/>
              </div>
              <!--                <el-divider></el-divider>-->
            </div>
            <!--            <el-form-item>-->
            <!--              <ScreeningLabelComponent v-if="!isEmpty(localHKThrust)" label="HKUST Hong Kong Campus"-->
            <!--                              :label-required="false"></ScreeningLabelComponent>-->

            <!--            </el-form-item>-->
            <div v-if="hkFacultyFlag">
              <div v-for="(hk_thrust, index) in this.templateData.hk_thrust"
                   :key="index">
                <!--                <p style="font-size: 20px">{{ localHKThrustNames[name] }}</p>-->
                <div
                    v-if="availableUnit.includes(correctThrust(hk_thrust)) || highPrivilegeCondition() || referToListFlag">
                  <el-tag effect="dark" style="margin-right: 1vw" :color="otherHubCheckBoxColor(hk_thrust, 'hk')"
                          :class="otherHubCheckBoxClass(hk_thrust, 'hk')">{{
                      getAbbreviation(hk_thrust)
                    }}
                  </el-tag>
                  <el-tag effect="dark" style="margin-right: 1vw"
                          v-if="thrustPoints.hk[hk_thrust] && pointsDataCondition(thrustPoints.hk[hk_thrust], hk_thrust)" :color="otherHubCheckBoxColor(hk_thrust, 'hk')"
                          :class="otherHubCheckBoxClass(hk_thrust, 'hk')">
                    # of
                    Reviewer: {{ thrustPoints.hk[hk_thrust].numOfReviewer.toPrecision(1) }},
                    Avg: {{ thrustPoints.hk[hk_thrust].avg.toPrecision(2) }}, Highest Point:
                    {{ thrustPoints.hk[hk_thrust].highestPoint.toPrecision(2) }}
                  </el-tag>
                  <span v-if="!declineRecommendFlag">
                  <el-select v-model="screeningStatus[hk_thrust]" placeholder="Select Status"
                             :disabled="offerStatusTest(screeningStatus[hk_thrust], hk_thrust)"
                             v-if="statusCondition(thrustPoints.hk[hk_thrust], hk_thrust) != 'none'">
                    <el-option
                        v-for="item in statusOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-select>
                    <!--                  <el-select v-model="screeningStatus[hk_thrust]" placeholder="Select Status"-->
                    <!--                             :disabled="offerStatusTest(screeningStatus[hk_thrust], hk_thrust)"-->
                    <!--                             v-if="statusCondition(thrustPoints.hk[hk_thrust], hk_thrust) == 'decline_disable'">-->
                    <!--                    <el-option-->
                    <!--                        v-for="item in statusOptionsDeclineDisable"-->
                    <!--                        :key="item.value"-->
                    <!--                        :label="item.label"-->
                    <!--                        :value="item.value">-->
                    <!--                    </el-option>-->
                    <!--                  </el-select>-->
                  <el-button style="margin-left: 10px"
                             :disabled="offerStatusTest(screeningStatus[hk_thrust], hk_thrust)"
                             @click="submitStatus(screeningStatus[hk_thrust],'hk', hk_thrust)"
                             v-if="statusCondition(thrustPoints.hk[hk_thrust], hk_thrust) != 'none'">
                    Submit Status
                  </el-button>
                    <!--                  <el-button style="margin-left: 10px"-->
                    <!--                             @click="sendDeclineRecommendation(hk_thrust)"-->
                    <!--                             type="warning"-->
                    <!--                             v-if="statusCondition(thrustPoints.hk[hk_thrust], hk_thrust) == 'decline_disable'">-->
                    <!--                    Recommend For Decline-->
                    <!--                  </el-button>-->
                    <!--                  <el-popover-->
                    <!--                      placement="top-start"-->
                    <!--                      width="500"-->
                    <!--                      trigger="hover"-->
                    <!--                      :content="itemDescription.declineRecommendDescription"-->
                    <!--                      v-if="statusCondition(thrustPoints.hk[hk_thrust], hk_thrust) == 'decline_disable'">-->
                    <!--                    <i style="margin-left: 5px" slot="reference" class="el-icon-info"></i>-->
                    <!--                  </el-popover>-->
                  </span>
                  <!--                  <span v-if="declineRecommendFlag && hk_thrust == currentDeclinedUnit && unitRoleDetection(hk_thrust, 'Dean')">-->
                  <!--                  <el-button-->
                  <!--                      type="success"-->
                  <!--                      @click="declineRecommendOperation('Approved')">-->
                  <!--                    Approve-->
                  <!--                  </el-button>-->
                  <!--                  <el-button-->
                  <!--                      type="danger"-->
                  <!--                      @click="declineRecommendOperation('Rejected')">-->
                  <!--                    Reject-->
                  <!--                  </el-button>-->
                  <!--                </span>-->
                  <br/>
                  <br/>
                </div>
                <!--                <el-divider></el-divider>-->
              </div>
            </div>
            <div v-if="declineAllDetect()">
              <el-button type="danger" @click="declineAll">Quick Decline</el-button>
              <div v-if="qDeclineReviewerInfo.length > 0" style="margin-top: 15px">
                This applicant was quick-declined by:
              </div>
              <div v-for="(info, index) in qDeclineReviewerInfo" :key="index" style="margin-top: 15px">
                <el-tag>
                  {{ info.name }} ({{ info.createTime.split("T")[0] }})
                </el-tag>
              </div>
            </div>
          </div>
          <el-divider></el-divider>
          <br/>
          <div id="academic-qualification">
            <h4>Academic Qualifications</h4>
            <div style="margin-top: 15px" v-for="(info,index) in templateData.academic_info" :key="index">
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-form-item
                      :prop="'academic_info.'+index+'.qualification_institution'"
                      :rules="{required: true, message: 'Please fill in the institution for qualification', trigger: 'change'}">
                    <ScreeningLabelComponent label="Education Institution"></ScreeningLabelComponent>
                    <el-autocomplete
                        :disabled="true"
                        style="width: 100%"
                        v-model="info.qualification_institution"
                        :trigger-on-focus="false"
                    ></el-autocomplete>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :prop="'academic_info.'+index+'.qualification_country'"
                                :rules="{required: true, message: 'Please fill in the country where receiving the qualification', trigger: 'change'}">
                    <ScreeningLabelComponent label="Country or Region"></ScreeningLabelComponent>
                    <el-input :disabled="true" v-model="info.qualification_country"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-form-item :prop="'academic_info.'+index+'.major'"
                                :rules="{required: true, message: 'Please enter major', trigger: 'change'}">
                    <ScreeningLabelComponent label="Major"></ScreeningLabelComponent>
                    <el-input :disabled="true" v-model="info.major"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :prop="'academic_info.'+index+'.qualification'"
                                :rules="{required: true, message: 'Please enter qualification', trigger: 'change'}">
                    <ScreeningLabelComponent label="Degree"></ScreeningLabelComponent>
                    <el-select v-if="!info.mandatory" v-model="info.qualification"
                               placeholder="please select your title" @change="supervisorDetect(info)" :disabled="true">
                      <el-option label="Associate Degree" value="Associate Degree"></el-option>
                      <el-option label="Bachelor's Degree" value="Bachelor's Degree"></el-option>
                      <el-option label="Master's Degree" value="Master's Degree"></el-option>
                      <el-option label="Doctorate Degree" value="Doctorate Degree"></el-option>
                      <!--                        <el-option label="Other" value="Other"></el-option>-->
                    </el-select>
                    <div v-if="info.mandatory">
                      {{ info.qualification }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10" v-if="'supervisor' in info">
                  <el-form-item :prop="'academic_info.'+index+'.supervisor'"
                                :rules="{required: true, message: 'Please enter supervisor\'s name', trigger: 'change'}">
                    <ScreeningLabelComponent label="Supervisor's Name"></ScreeningLabelComponent>
                    <el-input :disabled="true" v-model="info.supervisor"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :prop="'academic_info.'+index+'.qualification_period'"
                                :rules="{type: 'array', required: true, message: 'Please choose the period for qualification', trigger: 'change'}">
                    <ScreeningLabelComponent label="Period"></ScreeningLabelComponent>
                    <el-date-picker
                        :disabled="true"
                        v-model="info.qualification_period"
                        type="monthrange"
                        start-placeholder="Start date"
                        end-placeholder="End date"
                        :unlink-panels="true"
                        value-format="yyyy-MM">
                    </el-date-picker>
                  </el-form-item>
                  <el-tag v-if="academicToPresentDetect(index)">To Present</el-tag>
                </el-col>
              </el-row>
              <el-divider v-if="index !== templateData.academic_info.length - 1"></el-divider>
            </div>
          </div>
          <el-divider></el-divider>
          <br/>
          <div id="present-affiliation">
            <h4>Current Affiliation</h4>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item prop="affiliation_institution">
                  <ScreeningLabelComponent label="Institution"></ScreeningLabelComponent>
                  <el-input :disabled="true" v-model="templateData.affiliation_institution"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item prop="affiliation_country">
                  <ScreeningLabelComponent label="Country or Region"></ScreeningLabelComponent>
                  <el-input :disabled="true" v-model="templateData.affiliation_country"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item prop="affiliation_position">
                  <ScreeningLabelComponent label="Position"></ScreeningLabelComponent>
                  <el-input :disabled="true" v-model="templateData.affiliation_position"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item prop="affiliation_period">
                  <ScreeningLabelComponent label="Period"></ScreeningLabelComponent>
                  <el-date-picker
                      :disabled="true"
                      v-model="templateData.affiliation_period"
                      type="monthrange"
                      start-placeholder="Start date"
                      end-placeholder="End date"
                      :unlink-panels="true"
                      value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-tag v-if="templateData.affiliation_period_to_present">To Present</el-tag>
              </el-col>
            </el-row>
          </div>
          <el-divider></el-divider>
          <br/>
          <div id="referees_email">
            <h4>Referee(s)<el-popover
                placement="top-start"
                width="500"
                trigger="hover"
                :content="itemDescription.refereeLetterDesc">
              <i style="margin-left: 5px" slot="reference" class="el-icon-info"></i>
            </el-popover></h4>
            <div v-for="(referee,index) in templateData.referees" :key="index">
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-form-item
                      :prop="'referees.'+index+'.name'"
                      :rules="{required: true, message: 'Please fill in the name of referee', trigger: 'change'}">
                    <ScreeningLabelComponent :label="'Referee '+(index+1).toString()+' Name'"
                    ></ScreeningLabelComponent>
                    <el-input :disabled="true" v-model="referee.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                      :prop="'referees.'+index+'.email'"
                      :rules="[{required: true, message: 'Please fill in the email of referee', trigger: 'change'},
                              {type: 'email', message: 'Please fill in correct email address', trigger: 'change'}]">
                    <ScreeningLabelComponent :label="'Referee '+(index+1).toString()+' Email'"
                    ></ScreeningLabelComponent>
                    <el-input :disabled="true" :value="checkIfReferenceRefected(referee.email)"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="2">
                  <el-tag v-if="referenceLetterCheck(referee.name)">Received
                    ({{ getReferenceLetterTime(referee.name) }})
                  </el-tag>
                  <el-tag v-else>Not Received</el-tag>
                </el-col>
              </el-row>
              <br/>
            </div>
            <div v-if="templateData.referees.length === 0">
              <p>No Referee's Information provided</p>
            </div>
          </div>
          <el-divider></el-divider>
          <br/>
          <div id="team_member">
            <div class="popover-class">
              <h4>Team Member(s)
                <el-popover
                    placement="top-start"
                    width="500"
                    trigger="hover"
                    :content="itemDescription.teamMemberDescription">
                  <i slot="reference" class="el-icon-info"></i>
                </el-popover>
              </h4>
            </div>
            <div v-for="(team_member,index) in templateData.team_members" :key="index">
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-form-item
                      :prop="'team_members.'+index+'.name'"
                      :rules="{required: true, message: 'Please fill in the name of the team member', trigger: 'change'}">
                    <ScreeningLabelComponent :label="'Member '+(index+1).toString()+' Name'"
                    ></ScreeningLabelComponent>
                    <el-input :disabled="true" v-model="team_member.name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item
                      :prop="'team_members.'+index+'.email'"
                      :rules="[{required: true, message: 'Please fill in the email of the team member', trigger: 'change'},
                              {type: 'email', message: 'Please fill in correct email address', trigger: 'change'}]">
                    <ScreeningLabelComponent :label="'Member '+(index+1).toString()+' Email'"
                    ></ScreeningLabelComponent>
                    <el-input :disabled="true" v-model="team_member.email"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="10">
                  <el-form-item
                      :prop="'team_members.'+index+'.university'"
                      :rules="{required: true, message: 'Please fill in the university of the team member', trigger: 'change'}">
                    <ScreeningLabelComponent :label="'Member '+(index+1).toString()+' Institution'"
                    ></ScreeningLabelComponent>
                    <el-autocomplete
                        :disabled="true"
                        style="width: 100%"
                        v-model="team_member.university"
                        :trigger-on-focus="false"
                    ></el-autocomplete>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div v-if="templateData.team_members.length === 0">
              <p>No Specific Team member's Information provided</p>
            </div>
          </div>
        </el-main>
      </div>
      <br/>

    </el-form>
  </div>
</template>

<script>
import utilsMixin from "@/components/view/js/utilsMixin";
import ScreeningLabelComponent from "@/basic_components/ScreeningLabelComponent";
import hkFacultyjson from '@/assets/json/hkFacultyDepartments.json';
import gzThrustjson from '@/assets/json/gzThrust.json'
import description from '@/assets/json/description.json'
import thrustCorrectionMixin from "@/components/view/js/thrustCorrectionMixin";
import statusJson from "@/assets/json/status.json"
import statusNameJson from "@/assets/json/statusName.json"
import {Message} from "element-ui";
import thrustAbbreviationjson from "@/assets/json/ThrustAbbreviation.json";
import screeningAbbreviationMixin from "@/components/view/js/screeningAbbreviationMixin";
// import offerAdmin from "@/assets/json/offerAdmin.json"
import offerStatusButtonName from "@/assets/json/offerStatusButton.json"

export default {
  name: "ScreeningPersonalInfo",
  mixins: [utilsMixin, thrustCorrectionMixin, screeningAbbreviationMixin],
  components: {
    ScreeningLabelComponent,
  },
  props: {
    preboardingFlag: {
      type: Boolean,
      default: false
    },
    currentDeclinedRequester: {
      type: String,
      default: ''
    },
    currentDeclinedUnit: {
      type: String,
      default: ''
    },
    declineRecommendFlag: {
      type: Boolean,
      default: false
    },
    qDeclineReviewerInfo: {
      type: Array,
      default: () => []
    },
    reviewerId: {
      type: String,
      default: ''
    },
    referenceLetterInfo: {
      type: Array,
      default: () => []
    },
    templateData: {
      type: Object,
      default: () => {
      }
    },
    userName: {
      type: String,
      default: ''
    },
    thrustPoints: {
      type: Object,
      default: () => {
      }
    },
    thrustStatus: {
      type: Object,
      default: () => {
      }
    },
    availableUnit: {
      type: Array,
      default: () => []
    },
    role: {
      type: Object,
      default: () => {
      }
    },
    referToListFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      streamType: "Full Professor",
      streamTypeOptions: [
        {
          value: 'Full Professor',
          label: 'Full Professor'
        },
        {
          value: 'Associate Professor',
          label: 'Associate Professor'
        },
        {
          value: 'Assistant Professor',
          label: 'Assistant Professor'
        },
        {
          value: 'Research Track',
          label: 'Research Track'
        },
        {
          value: 'Teaching Track',
          label: 'Teaching Track'
        },
        {
          value: 'Visiting Faculty',
          label: 'Visiting Faculty'
        },
      ],
      reminderActiveName: "reminder-1",
      reminderStatus: "Hide",
      additionalData: {},
      offerStatusButtonName: offerStatusButtonName,
      offerStatus: "offering",
      offerSyncStatus: "",
      offerAdminFlag: false,
      offerThrustList: [],
      offerFlag: false,
      declineMessage: '',
      file_src: '',
      itemDescription: description,
      hkFacultyFlag: false,
      statusJson: statusJson,
      statusNameJson: statusNameJson,
      gzThrustDetail: gzThrustjson,
      hkFacultyDetail: hkFacultyjson,
      imagePath: require('../assets/img/recruitment_logo.jpeg'),
      footerImagePath: require('@/assets/img/white_GZ_logo_Eng.svg'),
      otherThrustFlag: false,
      screeningStatus: [],
      localGZThrust: {},
      localGZThrustKey: [],
      localHKThrust: {},
      localHKThrustKey: [],
      thrustAbbreviationjson: thrustAbbreviationjson,
      localGZThrustNames: {
        'Function': 'Function Hub',
        'Information': 'Information Hub',
        'Society': 'Society Hub',
        'Systems': 'Systems Hub',
        'Others': 'Priority Research Areas'
      },
      localHKThrustNames: {
        'Strategic_Hiring': 'Strategic Hiring',
        'Business': 'School of Business and Management',
        'Engineering': 'School of Engineering',
        'Humanities_and_Social_Science': 'School of Humanities and Social Science',
        'Interdisciplinary_Programs_Office': 'Academy of Interdisciplinary Studies',
        'Science': 'School of Science',
        'Others': 'Priority Research Areas'
      },
      statusOptions: [
        {
          value: 'Decline',
          label: 'Decline'
        },
        {
          value: 'Interview',
          label: 'Interview'
        },
        {
          value: 'Offer',
          label: 'Offer'
        },
        {
          value: 'Review State',
          label: 'Review State'
        },
        {
          value: 'Shortlist',
          label: 'Shortlist'
        }
      ],
      statusOptionsDeclineDisable: [
        {
          value: 'Interview',
          label: 'Interview'
        },
        {
          value: 'Offer',
          label: 'Offer'
        },
        {
          value: 'Review State',
          label: 'Review State'
        },
        {
          value: 'Shortlist',
          label: 'Shortlist'
        }
      ],
      onBoardingDate: ""
    }
  },
  created() {
    // let offerAdminData = offerAdmin
    if (this.preboardingFlag) {
      this.offerAdminFlag = true
      this.$request.fetchAdditionalData({"applicant": this.userName}).then(res => {
        if (res.data) {
          console.log(res.data)
          if (res.data.code === 10001) {
            this.offerStatus = "offering"
          } else {
            this.offerStatus = res.data.data.applicant_status
            this.offerSyncStatus = res.data.data.nc_sync_status
            this.additionalData = res.data.data
            this.onBoardingDate = this.additionalData.on_boarding_date
            console.log(this.offerStatus)
            console.log(this.additionalData)
          }
          this.dataPreparation();
        }
      }).catch((err) => {
        console.log(err);
        Message({
          message: err,
          type: "error"
        });
      });
    } else {
      this.dataPreparation();
    }
    console.log(this.templateData)
  },
  methods: {
    handleReminderChange(val) {
      console.log(val);
      if (val === "reminder-1") {
        this.reminderStatus = "Hide"
      } else {
        this.reminderStatus = "Show"
      }
    },
    offerStatusChange(thrust) {
      if (this.offerStatus === "offering" || this.offerStatus === "end") {
        this.$alert('offer will be given to ' + thrust + ' as ' + this.streamType, 'Warning', {
          confirmButtonText: 'OK',
          callback: action => {
            if (action == 'confirm') {
              this.$request.offerProcessing({
                "applicant": this.userName,
                "department": thrust,
                "streamType": this.streamType
              }).then(res => {
                if (res.data) {
                  console.log(res)
                  Message({
                    message: "offer sent operation confirmed",
                    type: "success"
                  })
                  this.$emit('updatePersonalData')
                }
              }).catch((err) => {
                console.log(err)
                Message({
                  message: "Submit Error",
                  type: "error"
                })
              });
            }
          }
        });
      } else if (this.offerStatus === "prepare" || this.offerStatus === "collecting") {
        if (this.offerStatus === "prepare") {
          this.additionalData.applicant_status = "collecting"
        }
        if(this.onBoardingDate == "" || this.onBoardingDate == null){
          Message({
            message: "Please selected the intended start date",
            type: "error"
          })
          return
        }
        console.log(this.onBoardingDate);
        this.$alert('Click Confirm to send a data collection email.', 'Warning', {
          confirmButtonText: 'Confirm',
          callback: action => {
            if (action == 'confirm') {
              this.$request.sendDataCollection({
                "applicant": this.userName,
                "on_boarding_date": this.onBoardingDate
              }).then(res => {
                if (res.data) {
                  console.log(res)
                  if (this.offerStatus === "prepare") {
                    Message({
                      message: "data collection link has been sent",
                      type: "success"
                    })
                  } else {
                    Message({
                      message: "data collection link has been sent again",
                      type: "success"
                    })
                  }
                  this.$emit('updatePersonalData')
                }
              }).catch((err) => {
                console.log(err)
                Message({
                  message: "Submit Error",
                  type: "error"
                })
              });
            }
          }
        });
      }
    },
    declineRecommendOperation(operation) {
      let declineRecommendOperationParameter = {
        "userId": this.reviewerId,
        "operation": operation,
        "applicantId": this.userName,
        "unit": this.getAbbreviationOriginal(this.currentDeclinedUnit),
        "requesterId": this.currentDeclinedRequester
      }
      console.log("declineRecommendOperationParameter")
      console.log(declineRecommendOperationParameter)
      this.$request.declineRecommendOperation(declineRecommendOperationParameter).then(res => {
        if (res.data) {
          console.log(res)
          Message({
            message: operation,
            type: "success"
          })
          this.$emit('dataChanged')
        }
      }).catch((err) => {
        console.log(err)
        Message({
          message: "Submit Error",
          type: "error"
        })
      });
    },
    sendDeclineRecommendation(unit) {
      var declineRecommendParameter = {
        "requester": this.reviewerId,
        "unit": unit,
        "applicantId": this.userName,
      }
      console.log(declineRecommendParameter)
      this.$request.recommendForDecline(declineRecommendParameter).then(res => {
        if (res.data) {
          console.log(res)
          Message({
            message: "decline recommend sended",
            type: "success"
          })
        }
      }).catch((err) => {
        console.log(err)
        Message({
          message: "Submit Error",
          type: "error"
        })
      });
    },
    declineAllDetect() {
      // if(this.referToListFlag){
      //   return false
      // }
      let updateStatus = []
      if (this.highPrivilegeCondition()) {
        this.declineMessage = 'You will decline this applicant for ALL academic units, including all Schools/ Hubs and Priority Areas.'
        for (let i = 0; i < this.templateData.hk_thrust.length; i++) {
          updateStatus.push({
            thrustOrDept: this.templateData.hk_thrust[i],
            campus: 'hk',
            status: statusNameJson["Decline"]
          })
        }
        for (let j = 0; j < this.templateData.thrust.length; j++) {
          updateStatus.push({
            thrustOrDept: this.templateData.thrust[j],
            campus: 'gz',
            status: statusNameJson["Decline"]
          })
        }
        this.declineAllStatus = updateStatus
      } else {
        this.declineMessage = 'You will decline this applicant for ALL your academic units only. The applicant will be still alive in other Schools/ Hubs or Priority Areas.'
        for (let i = 0; i < this.templateData.hk_thrust.length; i++) {
          if (this.unitRoleDetection(this.templateData.hk_thrust[i], "Dean"))
            updateStatus.push({
              thrustOrDept: this.templateData.hk_thrust[i],
              campus: 'hk',
              status: statusNameJson["Decline"]
            })
        }
        for (let j = 0; j < this.templateData.thrust.length; j++) {
          if (this.unitRoleDetection(this.templateData.thrust[j], "Dean"))
            updateStatus.push({
              thrustOrDept: this.templateData.thrust[j],
              campus: 'gz',
              status: statusNameJson["Decline"]
            })
        }
        this.declineAllStatus = updateStatus
      }
      if (updateStatus.length == 0) {
        return false
      } else {
        this.declineAllStatus = updateStatus
        return true
      }
    },
    declineAll() {
      this.$alert(this.declineMessage, 'Warning', {
        confirmButtonText: 'OK',
        callback: action => {
          if (action == 'confirm') {
            console.log(action)
            let statusParameter = {
              reviewer: this.reviewerId,
              applicant: this.userName,
              updateStatus: this.declineAllStatus,
              updateReviewType: "QDecline"
            }
            this.$request.updateReviewStatus(statusParameter).then(res => {
              if (res.data) {
                console.log(res)
                this.$emit('dataChanged')
                this.$emit('updatePersonalData')
                Message({
                  message: "Status Updated",
                  type: "success"
                })
              }
            }).catch((err) => {
              console.log(err)
              Message({
                message: "Status Update Error",
                type: "error"
              })
            });
          }
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        }
      });
    },
    unitRoleDetection(unit, roleName) {
      if (this.role.hasOwnProperty(this.getAbbreviationOriginal(unit))) {
        if (this.role[this.getAbbreviationOriginal(unit)] == roleName) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    highPrivilegeCondition() {
      // if(this.referToListFlag){
      //   return true
      // }
      if (this.role.hasOwnProperty("ALL")) {
        if (this.role["ALL"] == 'Provost' || this.role["ALL"] == 'VPIA' || this.role["ALL"] == 'SystemAdmin') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    pointsDataCondition(data, name) {
      let num = -1
      if (typeof data !== 'undefined') {
        if (data.hasOwnProperty("numOfReviewer")) {
          num = data.numOfReviewer
        }
      }
      console.log(name)
      console.log(this.role)
      if (this.highPrivilegeCondition() || this.referToListFlag) {
        return true
      }
      if ((this.unitRoleDetection(name, "Reviewer") || this.unitRoleDetection(name, "Search Committee Member")) && num < 3) {
        return false
      } else {
        return true
      }
    },
    offerStatusTest(data, name) {
      //seems redundant
      if (!this.offerFlag) {
        return false
      } else {
        if (this.offerThrustList.includes(name)) {
          return false
        } else {
          return true
        }
      }
    },
    offerStatusPositiveTest(name) {
      return !this.offerStatusTest("", name)
    },
    statusCondition(data, name) {
      // let num = -1
      // if (typeof data !== 'undefined') {
      //   if (data.hasOwnProperty("numOfReviewer")) {
      //     num = data.numOfReviewer
      //   }
      // }
      // can not change refer to applicant status
      // if(this.referToListFlag){
      //   return false
      // }
      if (this.highPrivilegeCondition() || this.unitRoleDetection(name, "Admin") || this.unitRoleDetection(name, "Dean")) {
        return 'decline_enable'
      } else {
        if (this.unitRoleDetection(name, "Head") || this.unitRoleDetection(name, "Search Committee Chair") || this.unitRoleDetection(name, "Thrust Admin")) {
          return 'decline_disable'
        } else {
          return 'none'
        }
      }
    },
    submitStatus(status, campus, unit) {
      let statusParameter = {
        reviewer: this.reviewerId,
        applicant: this.userName,
        updateStatus: [{thrustOrDept: unit, campus: campus, status: statusNameJson[status]}],
      }
      if (statusNameJson[status] === 9) {
        this.$alert(this.itemDescription.offerAlert, 'Warning', {
          confirmButtonText: 'OK',
          callback: action => {
            if (action == 'confirm') {
              this.$request.updateReviewStatus(statusParameter).then(res => {
                if (res.data) {
                  this.$emit('dataChanged')
                  this.$emit('updatePersonalData')
                  Message({
                    message: "Status Updated",
                    type: "success"
                  })
                }
              }).catch((err) => {
                console.log(err)
                Message({
                  message: "Status Update Error",
                  type: "error"
                })
              });
            }
          }
        });
      } else {
        this.$request.updateReviewStatus(statusParameter).then(res => {
          if (res.data) {
            this.$emit('dataChanged')
            this.$emit('updatePersonalData')
            Message({
              message: "Status Updated",
              type: "success"
            })
          }
        }).catch((err) => {
          console.log(err)
          Message({
            message: "Status Update Error",
            type: "error"
          })
        });
      }
    },
    getScreenStatus() {
      for (let i = 0; i < this.templateData.thrust.length; i++) {
        // this.screeningStatus[this.correctThrust(this.templateData.thrust[i])] = this.templateData.thrust[i]
        if (this.thrustStatus.gz.hasOwnProperty(this.templateData.thrust[i])) {
          if (this.statusJson[this.thrustStatus.gz[this.templateData.thrust[i]]] == "Offer") {
            this.offerFlag = true
            this.offerThrustList.push(this.templateData.thrust[i])
          }
          this.$set(this.screeningStatus, this.templateData.thrust[i], this.statusJson[this.thrustStatus.gz[this.templateData.thrust[i]]])
        } else {
          this.$set(this.screeningStatus, this.templateData.thrust[i], '')
        }
      }
      for (let i = 0; i < this.templateData.hk_thrust.length; i++) {
        if (this.thrustStatus.hk.hasOwnProperty(this.templateData.hk_thrust[i])) {
          if (this.statusJson[this.thrustStatus.hk[this.templateData.hk_thrust[i]]] == "Offer") {
            this.offerFlag = true
            this.offerThrustList.push(this.templateData.hk_thrust[i])
          }
          this.$set(this.screeningStatus, this.templateData.hk_thrust[i], this.statusJson[this.thrustStatus.hk[this.templateData.hk_thrust[i]]])
        } else {
          this.$set(this.screeningStatus, this.templateData.hk_thrust[i], '')
        }
        // this.screeningStatus[this.correctThrust(this.templateData.hk_thrust[i])] = this.templateData.hk_thrust[i]
      }
    },
    academicToPresentDetect(index) {
      return this.templateData.academic_info[index].to_present
    },
    referenceLetterCheck(name) {
      console.log(name)
      for (let i = 0; i < this.referenceLetterInfo.length; i++) {
        if (this.referenceLetterInfo[i].refereeName === name && this.referenceLetterInfo[i].submitted) {
          return true
        }
      }
      return false
    },
    getReferenceLetterTime(name) {
      for (let i = 0; i < this.referenceLetterInfo.length; i++) {
        if (this.referenceLetterInfo[i].refereeName === name && this.referenceLetterInfo[i].submitted) {
          return this.referenceLetterInfo[i].time.split(' ')[0]
        }
      }
      return ''
    },
    checkIfReferenceRefected(email) {
      for (let i = 0; i < this.referenceLetterInfo.length; i++) {
        if (this.referenceLetterInfo[i].email === email) {
          let refereeName = this.referenceLetterInfo[i].refereeName
          if (refereeName.toLowerCase() === "rejected reference letter") {
            return "Rejected reference letter";
          }
        }
      }
      return email
    },
    // otherThrustDetect(val) {
    //   if (val.includes("Others")) {
    //     return "Others"
    //   } else {
    //     return val
    //   }
    // },
    dataPreparation() {
      this.handleGzThrustData()
      this.handleHkThrustData()
      this.otherThrustTest();
      this.getScreenStatus()
      if (this.templateData.hk_thrust.length >= 1) {
        this.hkFacultyFlag = true
      }
    },
    handleGzThrustData() {
      for (var k in this.gzThrustDetail) {
        if (this.gzThrustDetail.hasOwnProperty(k)) {
          let currentList = []
          for (let i = 0; i < this.gzThrustDetail[k].length; i++) {
            if (this.templateData.thrust.includes(this.gzThrustDetail[k][i].name)) {
              currentList.push(this.gzThrustDetail[k][i].name)
            }
          }
          if (currentList.length > 0) {
            this.$set(this.localGZThrust, k, currentList)
            this.localGZThrustKey.push(k)
          }
        }
      }
      if (this.templateData.other_thrust_specify != '') {
        if (this.localGZThrust.hasOwnProperty('Others')) {
          let otherList = this.localGZThrust.Others.slice(0)
          otherList.push(this.templateData.other_thrust_specify + '(Others)')
          this.$set(this.localGZThrust, 'Others', otherList)
        } else {
          this.$set(this.localGZThrust, 'Others', [this.templateData.other_thrust_specify + '(Others)'])
          this.localGZThrustKey.push('Others')
        }
      }
    },
    handleHkThrustData() {
      for (var k in this.hkFacultyDetail) {
        if (this.hkFacultyDetail.hasOwnProperty(k)) {
          let currentList = []
          for (let i = 0; i < this.hkFacultyDetail[k].length; i++) {
            if (this.templateData.hk_thrust.includes(this.hkFacultyDetail[k][i].name)) {
              currentList.push(this.hkFacultyDetail[k][i].name)
            }
          }
          if (currentList.length > 0) {
            this.$set(this.localHKThrust, k, currentList)
            this.localHKThrustKey.push(k)
          }
        }
      }
    },
    closeIframe() {
      this.centerDialogVisible = false
    },
    otherThrustTest() {
      if (this.templateData['thrust'].includes('Others')) {
        this.otherThrustFlag = true
      } else {
        this.otherThrustFlag = false
        this.templateData.other_thrust_specify = ''
      }
    },
    id_generator(id) {
      return id.toString().replace(/\s+/gi, '_').replace(/\W/g, '').toLowerCase()
    },
  }
}
</script>

<style scoped>
.list-green-tag {
  margin-right: 1vw;
  border-color: #27AE60
}

.list-gold-tag {
  margin-right: 1vw;
  border-color: #946F34
}
</style>
